import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import PlaceholderReportScreen from './PlaceholderReportScreen';

const DailyMonthlySummaryReportScreen: React.FC = () => (
  <PlaceholderReportScreen
    title="Daily / Monthly Summary"
    description="Total bookings, revenue, ADR, occupancy %, cancellations and adjustments per day or month."
    icon={<IconSystem.chart size={18} />}
    phaseLabel="Coming in Phase 5"
    comingSoonHint="Roll-up dashboard for end-of-day and end-of-month review."
  />
);
export default DailyMonthlySummaryReportScreen;
